import React, { useEffect, useRef, useState } from "react";
// import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Auth from '../../../models/Auth';
import { t } from 'i18next';
import { Button, Input } from "reactstrap";
import MineError from "../../Commons/MineError";
import MineMessage from "../../Commons/MineMessage";

export default function QRCodeLogin(props) {
    const { portalId, clientId, username, session, mfaType, qrCode } = props
    const [verifyCode, setVerifyCode] = useState('');
    const [error, setError] = useState('');

    const maxTime = 30 * 60 * 1000;//30 minutes
    const [timer, setTimer] = useState(null);
    // const dispatch = useDispatch();
    const codeRef = useRef(null);

    useEffect(() => {
        console.log("Effect running only on mount phase");
        console.log('Start time', new Date())
        setTimer(setTimeout(() => {
            props.CLEAR_USER_SESSION()
            console.log('End time', new Date())
        }, maxTime))

        setTimeout(() => {
            if (codeRef.current) {
                codeRef.current.focus()
            }
        }, 2000)
    }, []);

    const onChangeInput = (event) => {
        let { value } = event.target
        setVerifyCode(value);
    }

    const onMFAVerifyUser = async () => {
        let error = ''
        if (!username || !session) {
            error = t(`MsgErrorUsernamePasswordNotFound`)
            setError(error);
            return ;//toast.error(error)
        }

        if (!verifyCode) {
            error = t(`MsgErrorProvideVerificationCode`)
            setError(error);
            return ;//toast.error(error)
        }
        setError('');
        let payload = {
            portalId,
            verifyCode,
            username,
            // password,
            clientId,
            session,
            mfaType
        }

        let data = await props.VERIFY_USER_MFA(payload)

        error = data?.authLoginError
        console.log('result', data)
        console.log('error?', error)
        if (error) {
            setError(error);
            //toast.error(error)
            if (codeRef.current /*&& error.includes('Code mismatch')*/) {
                codeRef.current.focus()
                codeRef.current.select()
            }
            return props.SET_LOGIN_AUTH_ERROR(null)
        }

        if (Auth.token && !Auth.isTokenExpired) {
            props.onNext()
            props.CLEAR_USER_SESSION()
            if (timer) {
                clearTimeout(timer)
                setTimer(null)
            }
        }
    }

    const onEnter = (e) => {
        if (e.keyCode === 13) {
            onMFAVerifyUser()
        }
    }

    return (
        <div>
            <h4 className="signin-text">
                <div>Authenticator</div>
                <div>QR Code</div>
            </h4>
            <div className="row">
                <div className="col-12 text-center">
                    <img src={qrCode} className="qr-code" alt="Scan-QRCode" />
                </div>
                <div className="col-12 mt-2 qr-code-text">
                    Scan QR code on Authenticator App
                </div>
            </div>
            <div className="mt-4">
                <div className='row' style={{}}>
                    <div className='col-12 mt-4 text-center verify-code-text' >
                        Please provide the Authenticator Code here.
                    </div>
                    <div className='col-7 mt-2 text-right'>
                        <Input innerRef={codeRef} className="cp-input-box" type="text" placeholder="Verify Code" name="verifyCode" id="verifyCode"
                            value={verifyCode} required onChange={onChangeInput} onKeyDown={onEnter} />
                    </div>
                    <div className='col-5 mt-2'>
                        <Button disabled={!verifyCode || verifyCode.length < 6} style={{ borderRadius: '0.5rem' }} color="primary" size="lg" className="btn-block" type="button" onClick={onMFAVerifyUser}>
                            Verify
                        </Button>
                    </div>
                </div>
            </div>
            {error ?
                <>
                    <div className="mt-2">
                        <MineError message={error}></MineError>
                    </div>
                    <div className="mt-2">
                        <MineMessage message={`As the name, Time-based One-Time Password. Time is very important. Please make sure your device time is time-synced`}></MineMessage>
                    </div>
                </> : null
            }

        </div>
    );
}